import React from "react";
import OrganizerDetails from "./OrganizerDetails.jsx";
import MultipleOrganizers from "./MultipleOrganizers.jsx";
import OrganizerSkeleton from "./Skeletons/OrganizerSkeleton.jsx";
import Card from "../common/Card.jsx";

export default function OrganizerCard({ loading, organizers }) {
  if (loading) return <OrganizerSkeleton />;

  return (
    <>
      {organizers?.length === 1 && (
        <div className="SingleOrganizerContainer">
          <Card
            title={playdetailsv2_resources.Organizer}
            icon="/Site/images/icons/EventPage/organizerIcon.svg"
            size="bold"
            id="r_OrganizerContainerMain"
            noContentPadding
            noMargin
          >
            <OrganizerDetails organizer={organizers[0]} />
          </Card>
        </div>
      )}
      {organizers?.length > 1 && (
        <div className="MultipleOrganizersContainer">
          <MultipleOrganizers organizers={organizers} />
        </div>
      )}
    </>
  );
}
